<template>
    <div class="wrap">
        <div class="container">
            <div class="help_title">
                <p>{{agreement.name}}</p>
                <p></p>
            </div>
            <van-divider :style="{ borderColor: '#eee', margin: '0' }"></van-divider>
            <div class="help" v-html="agreement.value">
				
				
			</div>
        </div>
        <v-foot></v-foot>
    </div>
</template>

<script>
	var _this;
    // @ is an alias to /src
    export default {
        components: {},
		created() {
			_this = this;
			this.document = this.$route.query.document;
			this.getData(this.document);
		},
        watch: {
            $route: {
                handler() {
                    this.document = this.$route.query.document;
                    this.getData(this.document);
                    //深度监听，同时也可监听到param参数变化
                },
                deep: true,
            }
        },
		
        data() {
			return {
				"document":0,
				"agreement":[],			
			}
        },
        methods: {
			getData(document){
				this.POST("api/agreement/index",{"document":document},function(d){
					// window.console.log(d);
					if(d.code == 0){
						_this.agreement = d.data;
					}else{
						_this.$toast(d.msg);
					}
				});
			},
        },
    }
</script>